"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpoints = void 0;
var breakpoints = {
  mobileBreakpoint: '320px',
  tabletBreakpoint: '768px',
  computerBreakpoint: '992px',
  mediumMonitorBreakpoint: '1280px',
  largeMonitorBreakpoint: '1400px',
  widescreenMonitorBreakpoint: '1920px',
  ultraWidescreenMonitorBreakpoint: '2560px'
};
exports.breakpoints = breakpoints;
//# sourceMappingURL=breakpoints.js.map